export default __webpack_public_path__ + "static/media/5.cc1958ed.png";